import Clear from '@/layouts/Clear.vue';

export default {
  path: '/companies',
  component: Clear,
  children: [
    {
      path: '',
      name: 'companies',
      component: () => import('@/views/Companies/CompanyList.vue'),
    },
    {
      path: ':id?',
      name: 'companies.form',
      component: () => import('@/views/Companies/CompanyForm.vue'),
    },
    {
      path: ':company/patient/:id?',
      name: 'companies.patients.form',
      component: () => import('@/views/Companies/CompanyPatientForm.vue'),
    },
  ],
};
